export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const GET_TREND = "GET_TREND";
export const GET_MOVIE = "GET_MOVIE";
export const GET_CAST = "GET_CAST";
export const GET_ACTOR = "GET_ACTOR";
export const GET_SEARCH = "GET_SEARCH";
export const LOAD_MORE = "GET_SEARCH";
export const RESET = "RESET";
export const posterQuery = "https://image.tmdb.org/t/p/w300";
